import { Heading, Text, Flex, Tag, NextImage } from '@dapperlabs/core-fe';
import React from 'react';

interface Props {
  cardHeading: string;
  cardImgSrc: string;
  cardText: string;
  tagLabel?: string;
}

export const MomentsUsageCard: React.FC<Props> = ({
  cardHeading,
  cardText,
  cardImgSrc,
  tagLabel,
}) => {
  return (
    <Flex direction='column'>
      <NextImage width={373} height={350} src={cardImgSrc} />
      <Heading as='h3' pt={['1rem', '1.5rem']} fontSize='1.125rem'>
        {cardHeading}
      </Heading>
      <Text pt={2} fontSize={['sm', 'sm', 'lg']}>
        {cardText}
      </Text>
      {tagLabel && (
        <Tag
          width='fit-content'
          mt={2}
          color='gray.50'
          fontFamily='mono'
          fontSize='12px'
          letterSpacing='0.6px'
          border='1px solid #393b45'
          bgColor='#212127'
        >
          {tagLabel}
        </Tag>
      )}
    </Flex>
  );
};
